import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/projects/synergy/assets/img/card-off/logo-synergy-id.svg'


const _hoisted_1 = { class: "c-card-off" }
const _hoisted_2 = { class: "c-card-off__section" }
const _hoisted_3 = { class: "c-card-off__info" }
const _hoisted_4 = { class: "c-card-off__info-content" }
const _hoisted_5 = { class: "c-card-off__info-title" }
const _hoisted_6 = { class: "c-card-off__info-subtitle" }
const _hoisted_7 = {
  key: 0,
  class: "c-card-off__info-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "c-card-off__img-wrapper" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("img", {
            src: _imports_0,
            alt: "avatar",
            class: "c-card-off__info-img"
          }, null, -1)),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.subtitle), 1),
          (_ctx.details)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.details), 1))
            : _createCommentVNode("", true),
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "c-card-off__info-text" }, [
            _createTextVNode(" Для решения срочных вопросов свяжитесь со службой поддержки "),
            _createElementVNode("a", {
              href: "mailto:help@synergyfriends.ru",
              class: "c-card-off__info-text--color"
            }, " help@synergyfriends.ru ")
          ], -1))
        ])
      ])
    ])
  ]))
}